import { createEvent } from '../../shared/utils/tracking.utils';

export const authenticationEvent = createEvent<{
  method: 'password' | 'token-link';
}>('Login');

export const logoutEvent = createEvent('Log out');

export const loginPageShownEvent = createEvent('Login Page Shown');

export const authenticationErrorEvent = createEvent<{ username: string }>('LoginError');

export const passwordResetEvent = createEvent<{ email: string }>('Password Reset');

export const passwordResetRequestEvent = createEvent<{ email: string }>('Password Reset Requested');

export const redirectedToLoginPage = createEvent('Redirected To Login Page');

export const notificationPreferencesUpdated = createEvent('Notification Preferences Updated');
export const pushEnabled = createEvent('Push notifications Enabled');
export const pushDisabled = createEvent('Push notifications Disabled');
